import axios from 'axios';

// 后端接口地址
//var baseUrlVal="https://john.ngrok.gzyunku.com/ssscreen-api"
var baseUrlVal="http://localhost:8080/ssscreen-api"
if (process.env.NODE_ENV === 'production') {
  baseUrlVal="https://user.ssscreen.cn/ssscreen-api"
}

const service = axios.create({
  baseURL: baseUrlVal,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  }
});

// 请求拦截器
service.interceptors.request.use(config => {
  //console.log(config);
  /*if (config.url === '/user/getUserInfo') {
    console.log(config.url);
  }*/
  //const token = localStorage.getItem('token');
  //if (token) config.headers['Authorization'] = token;
  return config;
}, error => Promise.reject(error));

// 响应拦截器
service.interceptors.response.use(
  response => {
    /*console.log(response);
    try {
      if (response.config.url === '/user/getUserInfo') {
        console.log(response.config.url);
        if (response.status === 401) {
          console.log(401);
          this.$router.push('/login');
          return;
        }
      }
    } catch (err) {
      //
    }*/
    return response.data;
  },
  error => {
    //console.log(error);
    return Promise.reject(error);
  }
);

export default service;